import { apiRequest } from "./client";
import type { CommentDto } from "./types";

export const getTreeComments = (treeId: string, token: string): Promise<CommentDto[]> =>
	apiRequest<CommentDto[]>(`/trees/${treeId}/comments`, { token });

export type AddCommentPayload = {
	body: string;
	parentCommentId?: string;
};

export const addComment = (treeId: string, payload: AddCommentPayload, token: string): Promise<CommentDto> =>
	apiRequest<CommentDto>(`/trees/${treeId}/comments`, { method: "POST", body: payload, token });

export const updateComment = (treeId: string, commentId: string, body: string, token: string): Promise<CommentDto> =>
	apiRequest<CommentDto>(`/trees/${treeId}/comments/${commentId}`, { method: "PUT", body: { body }, token });

export const deleteComment = (treeId: string, commentId: string, token: string): Promise<void> =>
	apiRequest<void>(`/trees/${treeId}/comments/${commentId}`, { method: "DELETE", token });

export const likeComment = (treeId: string, commentId: string, token: string): Promise<void> =>
	apiRequest<void>(`/trees/${treeId}/comments/${commentId}/like`, { method: "POST", token });

export const unlikeComment = (treeId: string, commentId: string, token: string): Promise<void> =>
	apiRequest<void>(`/trees/${treeId}/comments/${commentId}/like`, { method: "DELETE", token });
